"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOP_AREA_BANNER_BENEFIT_BANNER_SKELETON = void 0;
const TOP_AREA_BANNER_BENEFIT_BANNER_SKELETON = exports.TOP_AREA_BANNER_BENEFIT_BANNER_SKELETON = 'top-area-banner-benefit-banner-skeleton';